import React from 'react';

import ContentTicker from '@swf/components/ContentTicker/ContentTicker';
import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';

import {
  TXTWCL_FAMILYX_SOCIAL_LIFEX_FINANCIAL_ELL,
  TXTWCL_GAMBLING_CAN_BE_RISKYX_DEBTSX__ELL,
  TXTWCL_TO_GET_HELPX_CALL_N0_XNON_OVER_ELL
} from './RegulatoryHeaderFR.messages.json';
import styles from './RegulatoryHeaderFR.scss';

const RegulatoryHeaderFR: React.FC = () => {
  const joueurs = useResolver(ResolverTag.Joueurs);

  return (
    <a href={joueurs} target="_blank" rel="noopener noreferrer" className={styles.regulatoryHeader}>
      <ContentTicker interval={6}>
        <Translation {...TXTWCL_GAMBLING_CAN_BE_RISKYX_DEBTSX__ELL} />
        <Translation {...TXTWCL_FAMILYX_SOCIAL_LIFEX_FINANCIAL_ELL} />
      </ContentTicker>
      <Translation
        {...TXTWCL_TO_GET_HELPX_CALL_N0_XNON_OVER_ELL}
        values={{ 0: '09-74-75-13-13' }}
      />
    </a>
  );
};

export default RegulatoryHeaderFR;
